import { CellAction } from "./cell-action";

import { Action } from "@/src/data/types";
import { ColumnDef } from "@tanstack/react-table";
import { showDate } from "../../../lib/dateFormater";
const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

export const columns: ColumnDef<Action>[] = [
  {
    accessorKey: "title",
    header: "TITRE",
  },
  {
    accessorKey: "image",
    header: "IMAGE",
    cell: ({ row }) => (
      <img
        src={`${uploadUrl}/initiatives/${row.original.image}`}
        className="w-16 rounded-lg h-14"
        alt=""
      />
    ),
  },

  {
    accessorKey: "description",
    header: "DESCRIPTION",
    cell: ({ row }) => {
      const message = row.original.description;
      return message.length > 10 ? `${message.slice(0, 10)}...` : message;
    },
  },

  {
    accessorKey: "date",
    header: "DATE",
    cell: ({ row }) => {
      return showDate(row.original.date);
    },
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
